import history from '../../util/history'

const toShowView = id => {
  history.push(`/daily/id/${id}/show`)

  return true
}

export default toShowView
